jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	playVideo();
	setupCarousel();
	
}

function playVideo(){
	
	jQuery("#play-video").click(function() {
		
		var current = jQuery(this);
		var videoId = current.attr("data-video-id");
		
		setupYouTubeVideo(videoId);

		jQuery("#flourish-hero").toggleClass("video-playing");
		
		if(!jQuery("#flourish-hero").hasClass("video-playing")) {
			stopYouTubeVideo();
		} 
		
	});
	
}

function setupYouTubeVideo(videoId) {
	  
	var player = new YT.Player('player', {
		height: '360',
		width: '640',
		videoId: videoId,
		playerVars: {
			'playsinline': 1
		},
		events: {
			'onReady': playWhenReady
		}
	});
	
	return player;
}

function playWhenReady(event) {
	event.target.playVideo();
}

function stopYouTubeVideo() {
	jQuery("iframe#player").remove();
	jQuery("#video-container").append("<div id='player' />");
}

function setupCarousel(){
	
	var currentSlide = 0;
	var controlSlide = 0;
	var maxSlides = jQuery('.slick.controls > div').length - 1;

	jQuery('.slick.main').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		rows: 1,
		slidesPerRow: 1,
		dots: true,
		arrows: false,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: true,
		draggable: false,
		swipe: false,
		adaptiveHeight: false,
		waitForAnimate: false,
		responsive: [
		{
		  breakpoint: 1200,
		  settings: {
		  	adaptiveHeight: true,
		  }
		}
	  ]
	});
	
	jQuery('.slick.controls').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		rows: 3,
		slidesPerRow: 2,
		dots: false,
		arrows: false,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: true,
		draggable: false,
		swipe: false,
		adaptiveHeight: false,
		focusOnSelect: true,
		waitForAnimate: false
	});
	
	jQuery("button.previous").on("click", function(){
		
		currentSlide = currentSlide-1 < 0 ? maxSlides : currentSlide-1;
		controlSlide = currentSlide > 0 ? Math.ceil(currentSlide / 5) - 1 : 0;
		
		jQuery('.slick.main').slick("slickGoTo", currentSlide);
		jQuery('.slick.controls').slick("slickGoTo", controlSlide);
		
		jQuery(".thumbnail-carousel .slide.active").removeClass("active");
		jQuery(".thumbnail-carousel .slick-active .slide[data-thumb='" + currentSlide + "']").addClass("active");

	});
	
	jQuery("button.next").on("click", function(){
		
		currentSlide = currentSlide+1 > maxSlides ? 0 : currentSlide+1;
		controlSlide = currentSlide > 0 ? Math.ceil(currentSlide / 5) - 1 : 0;
		
		jQuery('.slick.main').slick("slickGoTo", currentSlide);
		jQuery('.slick.controls').slick("slickGoTo", controlSlide);
		
		jQuery(".thumbnail-carousel .slide.active").removeClass("active");
		jQuery(".thumbnail-carousel .slick-active .slide[data-thumb='" + currentSlide + "']").addClass("active");
	
	});
	
	jQuery(".thumbnail-carousel .slide").on("click", function(){
		
		var current = jQuery(this);
		var index = current.data("thumb");
		
		currentSlide = index;
		controlSlide = currentSlide > 0 ? Math.ceil(currentSlide / 5) - 1 : 0;
		
		jQuery(".thumbnail-carousel .slide.active").removeClass("active");
		current.addClass("active");
		
		jQuery('.slick.main').slick("slickGoTo", index);
		
	});
	
	jQuery(".thumbnail-carousel .slick-active > div:first-child .slide:first-child").addClass("active");

}





